import React from 'react';

export default function Home() {
  return (
    <div
      className="grid grid-rows-[20px_1fr_20px] items-center justify-items-center min-h-screen p-8 pb-20 gap-16 sm:p-20 font-[family-name:var(--font-geist-sans)]"
      style={{
        display: 'grid',
        gridTemplateRows: '20px 1fr 20px',
        alignItems: 'center',
        justifyItems: 'center',
        minHeight: '100vh',
        padding: '5rem',
        paddingBottom: '5rem',
        gap: '4rem',
        fontFamily: 'Inter, sans-serif',
      }}
    >
      
    </div>
  );
}
